import { Checkbox as AntdCheckbox, type CheckboxProps } from 'antd'

export const Checkbox = (props: CheckboxProps) => <AntdCheckbox {...props} />
